// src/main.js

import axios from './plugins/axios';
import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import vuetify from './plugins/vuetify'; // path to vuetify export
import config from './config.js';

import App from './App.vue';
import router from './router';
import store from './store';

import Card from './components/Card';
import Operator from './components/Operator';
import Loading from './components/Loading';

Vue.config.productionTip = false;
Vue.component('s-loading', Loading);

window.Vue = Vue;
window.axios = axios;
window.store = store;
window.ApiUrl = config.ApiUrl;//the ApiUrl for the API calls
window.client_id = config.client_id;//the ApiUrl for the API calls

router.beforeEach((to, from, next) => {
	store.dispatch('cancelLoading');
	next();
  })
window.client_secret = config.client_secret;//the ApiUrl for the API calls

Vue.mixin(
{
	methods:
	{
		formatNumber(amount, precision) {
		  if (precision === undefined) {
			precision = 0;
		  }

		  return new Intl.NumberFormat('nl-NL', {
			minimumFractionDigits: precision,
			maximumFractionDigits: precision
		  }).format(amount);
		},
		
		toDateTime(datetime) {
			if(datetime == undefined){
				return '';
			}
			let d = this.convertDate(datetime);
			let datestring = d.toLocaleDateString('nl-NL', {
				day: 'numeric',
				month: 'long',
				year: 'numeric'
			});
			return datestring += ' om ' + d.toLocaleTimeString('nl-NL', {
				hour: '2-digit', minute:'2-digit'
			})
		},
		
		toDate(datetime) {
			if(datetime == undefined){
				return '';
			}
			
			let d = this.convertDate(datetime);
			return d.toLocaleDateString('nl-NL', {
				day: 'numeric',
				month: 'long',
				year: 'numeric'
			});
		},
		
		toShortDate(datetime) {
			if(datetime == undefined){
				return '';
			}
			
			let d = this.convertDate(datetime);
			return d.toLocaleDateString('nl-NL', {
				day: 'numeric',
				month: 'numeric',
				year: 'numeric'
			});
		},
		
		toShortFullDate(datetime) {
			if(datetime == undefined){
				return '';
			}
			
			let d = this.convertDate(datetime);
			return d.toLocaleDateString('nl-NL', {
				weekday: 'short',
				day: 'numeric',
				month: 'long',
				year: 'numeric'
			});
		},
		
		convertDate(datetime) {
			let datetimeParts = datetime.split(' ');
			let dateparts = datetimeParts[0].split('-');
			let year = parseInt(dateparts[0]);
			let month = parseInt(dateparts[1]) - 1;
			let day = parseInt(dateparts[2]);
			let hour = 0;
			let minute = 0;
			if(datetimeParts.length > 1)
			{
				let timeparts = datetimeParts[1].split(':');
				hour = parseInt(timeparts[0]);
				minute = parseInt(timeparts[1]);
			}
			return new Date(year, month, day, hour, minute);
		},
		
		may(permissions, permission, action)
		{
			return permissions[permission] != undefined && (permissions[permission] & action) > 0;
		},

		toRequests(filters)
		{
			let temp = JSON.parse(JSON.stringify(store.state.expectsOptions));
			temp.filters = filters;
			temp.page = 1;
			store.state.expectsOptions = JSON.parse(JSON.stringify(temp));
			let self = this;
			router.push('aanvragen', function(){ self.$vuetify.goTo('table'); });
		},

		toErrors(filters)
		{
			let temp = JSON.parse(JSON.stringify(store.state.malfunctionsOptions));
			temp.filters = filters;
			temp.page = 1;
			store.state.malfunctionsOptions = JSON.parse(JSON.stringify(temp));
			let self = this;
			router.push('storingen', function(){ self.$vuetify.goTo('table'); });
		},

		toConnections(filters)
		{
			let temp = JSON.parse(JSON.stringify(store.state.connectionsOptions));
			temp.filters = filters;
			temp.page = 1;
			store.state.connectionsOptions = JSON.parse(JSON.stringify(temp));
			let self = this;
			router.push('aansluitingen', function(){ self.$vuetify.goTo('table'); });
		},
	}
});
Vue.component('s-card', Card);


new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
